export enum DynamicModalAction {
  CLOSE,
  DOWNLOAD
}
